import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=2653e24a&"
import script from "./dropdown.js?vue&type=script&lang=js&"
export * from "./dropdown.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports